import PropTypes from 'prop-types';
import { VALID_DATATYPES } from './datatypes';
import { STRING_COMPARATORS, INT_COMPARATORS } from './modifiers';

export const VALUE_PROPTYPE = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

export const ATTRIBUTE_PROPTYPE = PropTypes.shape({
  value: VALUE_PROPTYPE,
  is_derived: PropTypes.bool,
});

export const ATTRIBUTE_TYPE_PROPTYPE = PropTypes.shape({
  attributes: PropTypes.arrayOf(ATTRIBUTE_PROPTYPE),
  datatype: PropTypes.oneOf(VALID_DATATYPES).isRequired,
  is_editable: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  listable: PropTypes.bool.isRequired,
  singleton: PropTypes.bool.isRequired,
});

export const SECTION_PROPTYPE = PropTypes.shape({
  description: PropTypes.string,
  name: PropTypes.string.isRequired,
  attribute_types: PropTypes.arrayOf(ATTRIBUTE_TYPE_PROPTYPE).isRequired,
});

export const GENRE_PROPTYPE = PropTypes.shape({
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(SECTION_PROPTYPE).isRequired,
});

export const API_ITEM_PROPTYPE = PropTypes.oneOfType([
  ATTRIBUTE_PROPTYPE,
  ATTRIBUTE_TYPE_PROPTYPE,
  SECTION_PROPTYPE,
  GENRE_PROPTYPE,
]);

export const ATTRIBUTE_FILTER_PROPTYPE = PropTypes.shape({
  attributes: PropTypes.arrayOf(ATTRIBUTE_PROPTYPE),
  comparator: PropTypes.oneOf(INT_COMPARATORS.concat(STRING_COMPARATORS)),
  name: PropTypes.string,
  datatype: PropTypes.oneOf(VALID_DATATYPES),
  description: PropTypes.string,
  filteredValues: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
});

export const SELECTED_USER_PROPTYPE = PropTypes.shape({
  userId: PropTypes.number,
  name: PropTypes.string,
  phone: PropTypes.string,
});
